/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SurveyOverviewDetails = {
    properties: {
        total: {
    type: 'number',
    isRequired: true,
},
        data: {
    type: 'array',
    contains: {
        type: 'SurveyOverviewDetail',
    },
    isRequired: true,
},
    },
};